export type BinaryStrategyTypes = 'AI-driven' | 'Scene detection' | 'Manual';

export class BinaryStrategy {
  public isActive = false;
  public isDisabled = true;
  public isGenerating = false;

  constructor(private _name: BinaryStrategyTypes) {}

  getName() {
    return this._name;
  }

  getIntlKeyName() {
    return `binaryStrategies.${this._name.toLowerCase().replaceAll(' ', '')}`;
  }

  generateImages(datasetId: string, binaryId: string): Promise<any> {
    throw new Error('Method not implemented.');
  }

  enable() {
    this.isActive = true;
    this.isDisabled = false;
  }

  disable() {
    this.isActive = false;
    this.isDisabled = true;
  }
}
